// @ts-nocheck
import { RefreshCw } from 'lucide-react';
import { CenteredModal } from '../../../../components/CenteredModal';

/** Approve / Disapprove choice modal used by `ShareholderPortal`. Shows a spinner while signing. */
export const SignConsentModal = ({ open, signing, onApprove, onDisapprove, onClose }) => (
  <CenteredModal
    open={open}
    onClose={signing ? undefined : onClose}
    maxWidthClass="max-w-lg"
    zClassName="z-[60]"
    disableBackdropClose={signing}
  >
    {signing ? (
      <div className="p-12 text-center">
        <RefreshCw size={22} className="text-emerald-500 animate-spin mx-auto mb-4" />
        <p className="text-xs font-semibold text-gray-900">Executing via DocuSign...</p>
      </div>
    ) : (
      <div className="p-6 space-y-2">
        <button
          type="button"
          onClick={onApprove}
          className="w-full text-left px-4 py-3 rounded-lg border-2 border-emerald-200 hover:border-emerald-400 hover:bg-emerald-50/50 transition-all"
        >
          <div className="text-xs font-semibold text-gray-900">Approve</div>
        </button>
        <button
          type="button"
          onClick={onDisapprove}
          className="w-full text-left px-4 py-3 rounded-lg border-2 border-gray-200 hover:border-red-300 hover:bg-red-50/50 transition-all"
        >
          <div className="text-xs font-semibold text-gray-900">Disapprove</div>
        </button>
      </div>
    )}
  </CenteredModal>
);
